//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {BCarousel, BCarouselSlide, BProgress} from "bootstrap-vue";
import {mapGetters} from "vuex";
import {setRouter} from '@nuxeo/nuxeo-ui-elements/nuxeo-routing-behavior';
import {setI18n} from '@nuxeo/nuxeo-ui-elements/nuxeo-i18n-behavior';
import '@nuxeo/nuxeo-ui-elements/widgets/nuxeo-document-suggestion';
import '@nuxeo/nuxeo-ui-elements/widgets/nuxeo-directory-suggestion';
import '@nuxeo/nuxeo-ui-elements/widgets/nuxeo-user-suggestion';
import '@nuxeo/nuxeo-ui-elements/nuxeo-document-preview';
import _ from 'lodash';
import {annotationValues} from '@/constants';

setRouter({
  browse: () => '#'
});

setI18n({
  'en': {
    'selectivity.minChars': 'Please enter {0} or more characters',
    'selectivity.noResultsForTerm': "No results",
  },
});

function initialState() {
  return {
    headers: {
      properties: "*"
    },
    pageCount: 0,
    totalCount: 0,
    documentsToAnnotate: [],
    emptyResult: false,
    mission: {},
    endScreen: false,
    annotations: [],
    fullAnnotation: false,
    multiValue: false,
    loading: true,
    indexOutput: 0,
    annotationInfos: [],
    indexCategory: 0,
    indexDocument: 0,
    errorScreen: false,
    errorMessage: '',
    freeForm: false,
    freeFormInput: '',
    totalCategories: 0,
    totalOutputs: 0,
    annotationScreen: true,
    annotationLoadedValue: null,
  }
}

export default {
  name: "Annotation",
  components: {BCarouselSlide, BCarousel, BProgress},
  data() {
    return initialState();
  },
  mounted() {
    this.fetchAnnotations();
  },
  computed: {
    ...mapGetters(["projectId", 'urlCore']),
    missionScope() {
      if (this.mission.properties) {
        return this.mission.properties['dc:title'];
      }
      return "Mission";
    },
    progressSteps() {
      let progress, total;
      progress = this.indexDocument;
      total = this.pageCount;
      return ((progress / total) * 100).toFixed(0);
    },

    nextFullAnnotation() {
      if (this.annotations.length === 0) {
        // this.emptyResult = true;
        return {};
      } else {
        return this.annotations[this.indexOutput];
      }
    },

    annotation() {
      if (this.annotations.length === 0) {
        // this.emptyResult = true;
        return {};
      } else {
        return this.annotations[this.indexOutput];
      }
    },

    refURL() {
      return this.$refs.coreConnect.url + '/ui/#!/browse' + this.annotationLoadedValue.path
    }
  },
  methods: {
    _nxElementVisible: function (event) {
      event.target.$.s2.$.op.$.nx = this.$refs.coreConnect;
    },

    _valueLoaded: function (event) {
      if (event.target.response) {
        this.annotationLoadedValue = event.target.response;
      }

    },

    suggestionDocTriggered: function (doc) {
      this.freeFormInput = doc.detail.value.uid;
    },
    suggestionDirTriggered: function (doc) {
      let value = doc.detail.value;
      if (Array.isArray(value)) {
        this.freeFormInput = value.map(item => item.id);
      } else {
        this.freeFormInput = value.id;
      }
    },
    resetData: function () {
      Object.assign(this.$data, initialState());
    },
    fillAnnotations(annotationObjects) {
      Object.keys(annotationObjects).forEach((key) => {
        const annotation = {};
        annotation.property = key;
        annotation.multivalue = annotationObjects[key].multivalue;
        const categories = annotationObjects[key].categories;
        annotation.categories = Object.keys(annotationObjects[key].categories).sort((a, b) => (categories[a] > categories[b]) ? 1 : -1);
        this.annotations.push(annotation);
      });
    },
    fillAnnotationInfos(indexDocument, annotationObject, indexCategory, annotation) {
      if (!this.annotationInfos[indexDocument]) {
        this.annotationInfos[indexDocument] = {};
      }
      if (!this.annotationInfos[indexDocument].outputs) {
        this.annotationInfos[indexDocument].outputs = {};
      }
      if (!this.annotationInfos[indexDocument].outputs[annotationObject.property]) {
        this.annotationInfos[indexDocument].outputs[annotationObject.property] = {};
      }
      if (!this.annotationInfos[indexDocument].outputs[annotationObject.property].categories) {
        this.annotationInfos[indexDocument].outputs[annotationObject.property].categories = {};
      }
      const categoryValue = annotationObject.categories[indexCategory];
      this.annotationInfos[indexDocument].outputs[annotationObject.property].categories[categoryValue] = {
        type: annotation,
      }
    },
    stringifyDocument(doc) {
      if (doc) {
        delete doc._baseOptions;
        delete doc._repository;
        delete doc._nuxeo;
        delete doc._dirtyProperties;
        return JSON.stringify(doc);
      }
    },
    fetchDocument(docToAnnotate, request) {
      let url = [this.$refs.fetchDocument.$.nx.client._baseURL, `api/v1/id/${docToAnnotate.docId}`].join('/');
      url = url.replace(/(^\/+)|([^:])\/\/+/g, '$2/');

      let options = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'properties': '*',
          'enrichers.document': 's3directlink'
        },
        url,
      };

      return request.execute(options);
    },
    fetchAnnotations() {
      this.resetData();
      this.get('fetchMission').then((mission) => {
        this.mission = mission;
        this.$refs.fetchModel.docId = mission.properties['ai_mission:model'];
        this.get('fetchModel').then((model) => {
          this.get('fetchDocumentsToAnnotate').then((response) => {
            if (!response) {
              this.loading = false;
            } else {
              // Filling template variables
              const documents = response.documents;
              if (!documents || documents.length === 0) {
                this.emptyResult = true;
                this.annotationScreen = false;
                this.loading = false;
                return;
              }
              this.pageCount = documents.length;
              this.totalCount = response.count;

              // Handle annotations by following rules INSIGHT-648
              const annotationObjects = documents[0].annotation;
              this.fillAnnotations(annotationObjects);
              this.totalOutputs = this.annotations.length;
              this.totalCategories = this.annotations[0].categories.length;

              // If there is no category, set the free form directly
              if (!this.totalCategories || this.totalCategories === 0) {
                this.freeForm = true;
              }
              this.fullAnnotation = response['full_annotation'];

              // Fetching input(s)/output(s) resolution of documents to annotate
              const documentIds = documents.map((doc) => doc.docId);
              const inputs = model.properties["ai_model:inputs"].map((input) => input.name);
              const outputs = Object.keys(annotationObjects);

              // Try and retrieve each document and if it fails, remove it from the list
              let documentIdsWithRights = [];
              new Promise((parentResolve) => {   
                let count = 0;               
                documentIds.forEach((docId) => {
                  this.$refs.fetchDocument.$.nx.request().then((request) => {
                    this.fetchDocument({ docId: docId }, request).then(() => {
                      documentIdsWithRights.push(docId);
                    }).catch(() => {
                      console.log('Missing permissions to view document with id: ' + docId);
                    }).finally(() => {
                      count++;
                      if (count === documentIds.length) {
                        parentResolve();
                      }
                    });
                  });
                });
              }).finally(() => {     

                // build the request params including the documents with rights
                this.$refs.fetchResolutions.params = {
                  uids: documentIdsWithRights,
                  inputs: inputs,
                  outputs: outputs,
                };

                this.execute('fetchResolutions').then((content) => {

                // Merging filtered content with the inputs of the full document list
                this.documentsToAnnotate = _.map(content, (c) => {
                  return _.merge(c, _.find(documents, { 'docId': c.docId }));
                });
                
                let promises = [];
                this.documentsToAnnotate.forEach((docToAnnotate) => {
                  promises.push(this.$refs.fetchDocument.$.nx.request().then((request) => {
                    return this.fetchDocument(docToAnnotate, request);
                  }));
                  docToAnnotate.outputs.forEach((output) => {
                    this.annotations.forEach((annotation) => {
                      if (annotation.property === output.name) {
                        annotation.type = output.type;
                        annotation.resolver = output.resolver;
                        annotation.directory = output.directoryName;
                      }
                    })
                  });
                });
                
                Promise.all(promises).then((documents) => {
                  documents.forEach((doc, key) => {
                    if (doc.contextParameters && doc.contextParameters.s3directlink && doc.properties['file:content']
                      && doc.properties['file:content']['mime-type'] === "application/pdf") {
                      doc.properties['file:content'].data = doc.contextParameters.s3directlink.url;
                    }
                    this.documentsToAnnotate[key].document = doc;
                  });
                  this.loading = false;
                });
              }).catch(error => this.handleError(error));
            });
            }
          }).catch(error => this.handleError(error));
        }).catch(error => this.handleError(error));
      }).catch(error => this.handleError(error));
    },
    navigateToMission() {
      this.$router.push({name: "mission", params: {id: this.$router.history.current.params.id}});
    },
    isPreviewer(input) {
      return input.type === 'content';
    },
    isText(input) {
      return input.type === 'clob' || input.type === 'string';
    },
    isDocument(input) {
      return input.resolver === 'documentResolver';
    },
    isMultiText(input) {
      return input.isArray && !this.isDocument(input) && !this.isUser(input);
    },
    isUser(input) {
      return input.user === 'userManagerResolver';
    },
    isDirectory(input) {
      return input.resolver === 'directoryResolver';
    },
    handleError(error) {
      console.log(error);
      this.errorMessage = error;
      this.annotationScreen = false;
      this.errorScreen = true;
      this.loading = false;
    },
    get(object) {
      return this.$refs[`${object}`].get();
    },
    execute(object) {
      return this.$refs[`${object}`].execute();
    },
    updateDatalake(indexDocument) {
      // Update the active learning record(s) in Datalake
      this.$refs.annotate.path = `ai/missions/${this.projectId}/${this.$router.history.current.params.id}/${this.documentsToAnnotate[indexDocument].docId}/annotate`;
      this.$refs.annotate.data = this.annotationInfos[indexDocument];
      this.$refs.annotate.post().catch((error) => this.handleError(error));
    },
    updateDocument(value, nxDocument, annotationObject) {
      // Handle single value case when accepted
      if (!annotationObject.multivalue) {
        for (let i = this.indexCategory + 1; i <= this.annotations[this.indexOutput].categories.length - 1; i++) {
          this.removeFromDocument(annotationObject.categories[i], nxDocument, annotationObject);
          this.fillAnnotationInfos(this.indexDocument, annotationObject, i, "REJECTED");
        }
      }
      // Update the document accordingly
      const propertyName = annotationObject.property;
      const existingValue = _.find(nxDocument.outputs, (output) => {
        return output.name === propertyName;
      }).value;
      let property = {};
      if (this.isText(annotationObject) || this.isDocument(annotationObject) || this.isUser(annotationObject)) {
        if (existingValue === value) {
          return;
        }
        property[propertyName] = value;
      }
      if (this.isMultiText(annotationObject)) {
        if (existingValue.includes(value)) {
          return;
        }
        existingValue.push(value)
        property[propertyName] = existingValue;
      }

      this.$refs.annotationConfirmOp.input = nxDocument.docId
      this.$refs.annotationConfirmOp.params = {
        properties: property
      };

      this.$refs.annotationConfirmOp.execute();
    },
    removeFromDocument(value, document, annotationObject) {
      // Update the document accordingly
      const propertyName = annotationObject.property;
      const existingValue = _.find(document.outputs, (output) => {
        return output.name === propertyName;
      }).value;
      let property = {};
      if (this.isText(annotationObject) || this.isDocument(annotationObject) || this.isUser(annotationObject)) {
        if (existingValue !== value) {
          return;
        }
        property[propertyName] = null;
      }
      if (this.isMultiText(annotationObject)) {
        if (!existingValue.includes(value)) {
          return;
        }
        existingValue.push(null)
        property[propertyName] = existingValue;
      }
      // Update the doc
      this.$refs.document.data = {
        properties: property,
        "entity-type": "document"
      };
      this.$refs.document.docId = document.docId;
      this.$refs.document.put();
    },
    annotate(document, annotationObject, annotation) {
      this.freeFormInput = '';
      let annotated = false;

      switch (annotation) {
        case annotationValues.CONFIRMED:
        case annotationValues.HAND_INPUT:
          annotated = true;
          if (this.freeForm) {
            this.updateDocument(this.freeFormInput, document, annotationObject);
          } else {
            this.updateDocument(annotationObject.categories[this.indexCategory], document, annotationObject);
          }
          break;
        case annotationValues.REJECTED:
          this.removeFromDocument(annotationObject.categories[this.indexCategory], document, annotationObject);
          break;
        default:
      }

      this.fillAnnotationInfos(this.indexDocument, annotationObject, this.indexCategory, annotation);

      // Handle next document annotation
      this.next(!annotationObject.multivalue && annotated, annotationObject.categories);
    },
    handleNextFullAnnotation() {
      if (this.indexOutput !== this.annotations.length - 1) {
        this.indexCategory = 0;
        this.indexOutput++;
      } else {
        this.updateDatalake(this.indexDocument);
        this.indexDocument++;
        this.indexOutput = 0;
        this.indexCategory = 0;
        this.$refs.carousel.next();
        //need to re-trigger nuxeo-image-preview
        this.$refs.preview[this.indexDocument].document = this.documentsToAnnotate[this.indexDocument].document;
      }
    },
    resizeContent() {
      document.body.dispatchEvent(new Event('resize', {bubbles: true, cancelable: false}));
    },
    handleSkipFullAnnotation() {
      if (this.indexOutput !== this.annotations.length - 1) {
        this.indexCategory = 0;
        this.indexOutput++;
      } else {
        this.indexDocument++;
        this.indexOutput = 0;
        this.indexCategory = 0;
        this.$refs.carousel.next();
        //need to re-trigger nuxeo-image-preview
        this.$refs.preview.document = this.documentsToAnnotate[this.indexDocument].document;
      }
    },
    next(byPassSingleValueRule, categories, skip = false) {
      // Not the end of carousel or docs
      if (this.$refs.carousel.index !== this.pageCount - 1) {
        if (!this.fullAnnotation) {
          if (this.indexCategory !== categories.length - 1) {
            this.indexCategory++;
          } else {
            if (this.indexOutput === this.annotations.length - 1) {
              this.updateDatalake(this.indexDocument);
            }
            this.indexDocument++;
            this.$refs.carousel.next();
            //need to re-trigger nuxeo-image-preview
            this.$refs.preview.document = this.documentsToAnnotate[this.indexDocument].document;
          }
        } else {
          if (this.freeForm || byPassSingleValueRule) {
            this.freeForm = false;
            this.handleNextFullAnnotation();
            return;
          }
          if (this.indexCategory !== categories.length - 1) {
            this.indexCategory++;
          } else {
            if (skip) {
              this.handleSkipFullAnnotation();
              return;
            }
            this.freeForm = true;
          }
        }
        // End of carousel or docs
      } else {
        if (!this.fullAnnotation) {
          // not at the end of outputs
          if (this.indexOutput !== this.annotations.length - 1) {
            this.indexOutput++;
            this.indexCategory = 0;
            this.restart();
            // at the end of outputs
          } else {
            this.goToLastScreen();
          }
        } else {
          this.goToLastScreen();
        }
      }
    },
    goToLastScreen() {
      this.updateDatalake(this.indexDocument);
      this.annotationScreen = false;
      // Check if we still have documents to fetch
      if (this.totalCount === this.pageCount) {
        // Display we don't - go to empty screen
        this.emptyResult = true;
      } else {
        // Display we do - go to end screen (when you can ask for more)
        this.endScreen = true;
      }
    },
    skip(annotationObject) {
      this.freeFormInput = '';
      this.fillAnnotationInfos(this.indexDocument, annotationObject, this.indexCategory, annotationValues.NOT_SURE);
      this.next(false, annotationObject.categories, true);
    },
    restart() {
      this.$refs.carousel.setSlide(0);
    },
  }
}
